<loading-indicator [running]="loading$ | async" />

<call-event-overview [callEvents]="callEvents$ | async" (details)="showDetails($event)" />

@if ((loading$ | async) === false) {
	<action-button
		[disabled]="refreshing"
		[icon]="'fa fa-refresh' + (refreshing ? ' fa-spin' : '')"
		(action)="refresh()"
	/>
}
